<div class="toaster-container">
  <app-toaster
    *ngFor="let toaster of toasters; trackBy: trackByToasterId"
    [toaster]="toaster"
    (dismiss)="removeToaster($event)">
  </app-toaster>
</div>
